<template>
    <div>
        <div class="header">
            <div class="header-wapper flex flex-between">
                <div class="logo flex align-end">
                    <img src="../../assets/images/index/logo.png" />
                    蓝领人力资源服务平台
                </div>
                <div class="">
                    <router-link to="index/resume/list" class="white-btn flex flex-center">
                        我要招人
                        <img src="../../assets/images/index/user_icon.png"/>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="banner">
            <el-carousel :interval="5000" arrow="always" height="644px">
                <el-carousel-item v-for="item in bannerList" :key="item.id">
                    <img :src="item.imgUrl" />
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="notice">
            <div class="notice-wapper flex">
                <div class="notice-title flex">
                    <img src="../../assets/images/index/notice_icon.png" />
                    <span>公告通知</span>
                </div>
                <div class="notice-list flex-grow flex">
                    <router-link :to="{
                        path: '/index/home/notice/detail',
                        query: {
                            id: item.id
                        }
                    }" class="notice-item flex flex-between" v-for="item in noticeList" :key="item.id">
                        <div class="in-title">{{item.title}}</div>
                        <div class="notice-time">{{item.createdAt.split(' ')[0]}}</div>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="content-wapper">
                <div class="cont-title">名企招聘</div>
                <div class="famous-list flex flex-wrap">
                    <template v-for="(item, index) in famousList">
                        <div class="famous-item" :key="item.id + index" @mouseenter="handleChange(index, 'mouseenter')" @mouseleave="handleChange(null, '')">
                            <div class="hover" v-if="famousActive === index && methods ==='mouseenter' ">
                                <div class="resume-item flex flex-between" v-for="(resume, i) in item.recruitList" :key="'resume' + i" v-show="i < 2">
                                    <div class="resume-name flex">{{resume.positionName}}</div>
                                    <div class="resume-pay">{{resume.minSalary}}-{{resume.maxSalary}}/月</div>
                                </div>
                                <div class="more flex flex-center" @click="handleChange(index, 'click')">
                                    <img src="../../assets/images/index/file_search_icon.png" />
                                    查看岗位详情
                                </div>
                            </div>
                            <div class="click-show" v-else-if ="famousActive === index && methods ==='click'">
                                <div class="qr-title">扫描二维码查看企业</div>
                                <div class="qr-img"></div>
                                <div class="qr-desc flex-grow">找工作就来在他乡小程序</div>
                            </div>
                            <div class="default" v-else>
                                <div class="famous-logo">
                                    <img :src="item.companyLogo" />
                                </div>
                                <div class="famous-name">{{item.companyName}}</div>
                                <div class="famous-desc"><span>{{item.recruitList.length}}</span>个热招岗位</div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="cont-title">优质企业</div>
                <div class="quality-list flex flex-wrap">
                    <div class="quality-item" v-for="item in qualityList" :key="item.id">
                        <img :src="item.companyLogo" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            bannerList: [],
            famousList: [],
            qualityList: [],
            noticeList: [],
            famousActive: null, // 激活的企业名企
            methods: '' // mouseenter, click
        }
    },
    mounted () {
        this.getBannerList();
        this.getFamousList();
        this.getQualityList();
        this.getNoticeList();
    },
    methods: {
        getBannerList () {
            this.$http.get('/wapi/home/banner/list').then(res => {
                if (res.success) {
                    this.bannerList = res.data
                }
            })
        },
        // 名企招聘列表
        getFamousList () {
            this.$http.get('/wapi/home/company/famous/list').then(res => {
                if (res.success) {
                    this.famousList = res.data
                }
            })
        },
        // 获取优质企业列表
        getQualityList () {
            this.$http.get('/wapi/home/company/quality/list').then(res => {
                if (res.success) {
                    this.qualityList = res.data
                }
            })
        },
        // 获取通知列表
        getNoticeList () {
            this.axios.get(`/wapi/notice/list?pageNum=1&pageSize=2`).then(res => {
                if (res.code == 200) {
                    this.noticeList = res.rows;
                }
            })
        },
        handleChange(index, type){
            this.famousActive = index;
            this.methods = type;
        }
    }
}
</script>
<style lang="less" scoped>
@import url('../../assets/less/base.less');
.header{
    height: 4.6rem;
    padding: 0 12rem;
    color: #fff;
    font-size: 1.6rem;
    background: rgba(0,0,0,0.2);
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    line-height: 2.2rem;
    box-sizing: border-box;
    z-index: 999;
    .header-wapper{
        height: 100%;
        .logo{
            img{
                width: 8rem;
                height: 3.1rem;
            }
        }
    }
    .white-btn{
        width: 13.6rem;
        height: 3.4rem;
        background: #FFFFFF;
        border-radius: 0.4rem;
        font-size: 1.6rem;
        color: #1890FF;
        font-weight: 600;
        img{
            width: 2.4rem;
            height: 2.4rem;
            margin-left: 8px;
        }
    }
}
.banner{
    background: #057CF9;
    img{
        max-height: 100%;
        max-width: 100%;
    }
}
.notice{
    height: 6.4rem;
    background: #F8F8F8;
    padding: 0 15rem;
    margin-bottom: 4.3rem;
    .notice-wapper{
        height: 100%;
    }
    .notice-title{
        font-size: 2rem;
        font-weight: 500;
        color: #057CF9;
        line-height: 28px;
        // margin-right: 8rem;
        img{
            width: 2.4rem;
            height: 2.4rem;
            margin-right: 1.7rem;
        }
    }
    .notice-item{
        width: 50%;
        padding-left: 8rem;
        font-size: 2rem;
        color: #333333;
        .notice-time{
            color: #B5B5B5;
        }
    }
}
@padding-side: 4rem;
.content{
    padding: 0 12rem 10rem;
    .cont-title{
        padding: 0 @padding-side 1.4rem;
        border-bottom: 1px solid #E9E9E9;
        font-size: 2rem;
        color: #222222;
        font-weight: 500;
        line-height: 2.8rem;
        margin-bottom: 2.5rem;

    }
}
.famous-item{
    width: 26.2rem;
    height: 11.6rem;
    margin-bottom: 2.2rem;
    margin-right: 2.4rem;
    position: relative;
    &:nth-of-type(4n){
         margin-right: 0;
    }
    .default{
        width: 100%;
        height: 100%;
        border-radius: 4px;
        border: 1px solid #E6E6E6;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .famous-logo{
            width: 5rem;
            height: 5rem;
            margin-bottom: 7px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .famous-name{
            font-size: 14px;
            font-weight: 400;
            color: #494949;
            line-height: 20px;
        }
        .famous-desc{
            font-size: 12px;
            font-weight: 400;
            color: #A4A4A4;
            line-height: 17px;
            span{
                color: #057CF9;
            }
        }
    }
    .hover{
        width: 27rem;
        height: 12.2rem;
        background: #F5F8FF;
        box-shadow: 0px 0px 6px 5px rgba(229,236,241,0.39);
        border-radius: 4px;
        border: 1px solid #E6E6E6;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -13.5rem;
        margin-top: -6.1rem;
        box-sizing: border-box;
        padding: 2.9rem 2rem 0;
        .resume-item{
           font-size: 16px;
           color: #222222;
           .resume-name{
            font-size: 14px;
            color: #667087;
            &::before{
                content: '';
                width: 0.4rem;
                height: 0.4rem;
                background: #667087;
                border-radius: 50%;
                margin-right: 8px;
                display: block;
            }
           }
        }
        .more{
            margin-top: 1.8rem;
            font-size: 1.4rem;
            color: #057CF9;
            img{
                width: 16px;
                height: 16px;
                margin-right: 6px;
            }
        }
    }
    .click-show{
        width: 28.3rem;
        height: 26rem;
        background: #FFFFFF;
        position: absolute;
        top: 0;
        left: 50%;
        margin-left: -14.15rem;
        box-sizing: border-box;
        padding-top: 40px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .qr-title{
            font-size: 2rem;
            color: #333333;
            font-weight: 500;
            line-height: 2.8rem;
            margin-bottom: 2.4rem;
        }
        .qr-img{
            width: 15.3rem;
            height: 14.8rem;
            margin-bottom: 3rem;
        }
        .qr-desc{
            background: #057CF9;
            color: #fff;
            width: 100%;
        }
    }
}
.famous-list{
    margin-bottom: 4.2rem;
}
.quality-item{
    width: 124px;
    height: 102px;
    border-radius: 4px;
    border: 1px solid #E6E6E6;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 1.9rem;
    margin-bottom: 1.5rem;
    img{
        max-width: 100%;
        max-height: 100%;

    }
    &:nth-of-type(8n){
        margin-right: 0;
    }
}
</style>



// WEBPACK FOOTER //
// outerIndex.vue?75839490